const initialState = {
  machineProfiles: [],
  assignedKeys: [],
};

const licenseWizardReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_LICENSE_MACHINE_PROFILES":
      return { ...state, machineProfiles: action.payload };
    case "SET_LICENSE_ASSIGNED_KEYS":
      return { ...state, assignedKeys: action.payload };
    case "RESET_LICENSE_WIZARD":
      return initialState;
    default:
      return state;
  }
};

export default licenseWizardReducer;